module.exports = __webpack_public_path__ + "static/media/sfBuildLogo.18e8e734.png";